module.exports = __webpack_public_path__ + "img/reprint.7ecc2ca2.svg";